import {
  firstMenuMutation,
  firstMenuMapMutation,
  secondMenuMutation,
  secondMenuMapMutation,
  thirdMenuMutation,
  thirdMenuMapMutation
} from "../mutation-types.js";

const state = {
  systemName: '南京先河工程技术股份有限公司',
  systemNameEn: 'Nanjing Xianhe Engineering Technology Corportion',
  userInfo: JSON.parse(localStorage.getItem('XXXUserInfo')),
  /*文件上传*/
  // fileUploadServer: 'http://120.26.50.212/api/imageUpload/upload',
  fileUploadServer: 'http://admin.njxianhe.com/api/imageUpload/upload',
  imageToken: {'Authorization': localStorage.getItem('xianheSystemUserToken')},
  // baseImageUrl: 'http://120.26.50.212:3000',
  baseImageUrl: 'http://static.njxianhe.com',
  screen: localStorage.getItem('xianheSystemRatio') === '2' ? 'phone' : 'web',
  firstMenuMutation: [],
  firstMenuMapMutation: {},
  secondMenuMutation: [],
  secondMenuMapMutation: {},
  thirdMenuMutation: [],
  thirdMenuMapMutation: {},
};

const mutations = {
  // 一级导航
  [firstMenuMutation](state, data) {
    state.firstMenuMutation = data;
  },
  [firstMenuMapMutation](state, data) {
    state.firstMenuMapMutation = data;
  },
  // 二级导航
  [secondMenuMutation](state, data) {
    state.secondMenuMutation = data;
  },
  [secondMenuMapMutation](state, data) {
    state.secondMenuMapMutation = data;
  },
  // 三级导航
  [thirdMenuMutation](state, data) {
    state.thirdMenuMutation = data;
  },
  [thirdMenuMapMutation](state, data) {
    state.thirdMenuMapMutation = data;
  },
}

export default {
  state,
  mutations
}
